import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import DriversAppImage from '../../assets/img/drivers-app-sample-image.png';
import Background from '../../assets/img/onboarding/backgrounds/background.png';
import RoutalLogoWhite from '../../assets/img/routal-logo-white.svg';
import AppleBadge from '../../assets/img/store-badges/apple_US.svg';
import GoogleBadge from '../../assets/img/store-badges/google_US.png';
import Text from '../../react-components/Text';

interface DriversApplicationClaimProps {
  onBackToLogin: () => void;
}

export const DriversApplicationClaim = ({ onBackToLogin }: DriversApplicationClaimProps) => {
  return (
    <Grid
      container
      direction="column"
      style={{
        height: `100vh`,
        width: `100vw`,
        display: `flex`,
        flexDirection: `row`,
        justifyContent: `center`,
        backgroundImage: `url(${Background})`,
        backgroundSize: `cover`,
        padding: `10px`,
        overflowY: `auto`,
      }}
    >
      <Grid container alignItems="center" justifyContent="center" style={{ minHeight: `100px` }}>
        <img width="145" src={RoutalLogoWhite} alt="" />
      </Grid>

      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        wrap="nowrap"
        style={{
          maxWidth: `500px`,
          padding: `25px`,
          borderRadius: `30px`,
          background: RoutalPalette.neutral02n,
        }}
      >
        <Grid container direction="column" alignItems="center" wrap="nowrap">
          <Grid container direction="column" alignItems="center" wrap="nowrap">
            <Text
              variant="h4"
              isBold
              intlId="auth.drivers_app_claim.title"
              style={{ textAlign: `center`, color: RoutalPalette.primary80 }}
            />

            <VSpacer medium />

            <Text
              variant="body-large"
              intlId="auth.drivers_app_claim.subtitle"
              style={{ textAlign: `center`, color: RoutalPalette.secondary00 }}
            />
          </Grid>

          <VSpacer large />

          <img src={DriversAppImage} style={{ width: `180px` }} alt="Drivers App" />
        </Grid>

        <VSpacer large />

        <Grid container direction="column" alignItems="center" wrap="nowrap">
          <img
            src={AppleBadge}
            style={{ height: `52px` }}
            alt="Download on the App Store"
            onClick={() => (window.location.href = `https://apps.apple.com/es/app/routal/id6741764694`)}
          />

          <VSpacer small />

          <img
            src={GoogleBadge}
            style={{ height: `52px` }}
            alt="Get it on Google Play"
            onClick={() => (window.location.href = `https://play.google.com/store/apps/details?id=com.routal.drivers`)}
          />

          <VSpacer large />

          <Text
            variant="button"
            style={{
              color: RoutalPalette.secondary40,
            }}
            onClick={() => onBackToLogin()}
            intlId="auth.drivers_app_claim.back_to_login"
          />
        </Grid>
      </Grid>
      {/* </Grid> */}
    </Grid>
  );
};
